var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A92E5",
    d: "M5.654 20.682l-1.342-1.346L1 22.655 2.342 24zm10.07-11.547l1.187 5.478L19.32 9.57l5.521.506-4.004-3.867 2.164-5.166-4.871 2.674L13.987 0l.973 5.52-4.762 2.855z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3A92E5",
    d: "M2.916 2.339L4.26 3.545l1.594-.874-.707 1.686 1.31 1.265-1.807-.166-.776 1.623-.383-1.768-1.817-.25 1.557-.933-.315-1.79zm18.582 13l.887.796 1.055-.58-.467 1.116.867.838-1.198-.11-.509 1.066-.252-1.162-1.207-.166 1.031-.618-.208-1.18zm-8.39 4l.463.414.555-.305-.245.586.456.441-.63-.058-.263.548-.13-.6-.64-.088.542-.325-.108-.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A92E5",
    d: "M15.428 10.89l-.252-1.164-1.118-.153-9.279 9.296 1.342 1.345z"
  }))));
}
export default SvgMagicWand;